import { createContext, useContext, type ReactNode } from "react";

// A lineage diagram supplied by the card around an artifact, drawn in place of
// the fetched one. For cards whose artifact lives in a conversation the reader
// cannot open, such as a project pin, where the lineage endpoint is out of
// reach.
const LineageDiagramContext = createContext<string | null>(null);

export const LineageDiagramProvider = ({
  diagram,
  children,
}: {
  diagram: string;
  children: ReactNode;
}) => <LineageDiagramContext.Provider value={diagram}>{children}</LineageDiagramContext.Provider>;

export const useLineageDiagram = (): string | null => useContext(LineageDiagramContext);
